import { useMutation } from '@tanstack/react-query';

import { ConnectPageData, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const archivePage = (data: ConnectPageData): Promise<void> => {
  return axios.post(`/${PLATFORM_URL_SEGMENT[data.platform]}/pages/archive`, data);
};

type ConnectPageOptions = {
  config?: MutationConfig<typeof archivePage>;
};

export function useArchivePage({ config = {} }: ConnectPageOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['pages']);
    },
    ...config,
    mutationFn: archivePage,
  });
}
